import $ from 'jquery';

$(document).ready(function() {
    $('.js-slide-lecture').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3.2,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        {
            breakpoint: 1620,
            settings: {
                slidesToShow: 2.6,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 1100,
            settings: {
                slidesToShow: 1.4,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.6,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
           }
        }
        ]
    });
    $(window).on('resize', function() {
        $('.js-slide-lecture').slick('resize');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/index/slide-lecture.js